<template>
  <div>
    <v-row :no-gutters="$root.isMobile" :class="$root.isMobile ? 'mt-2' : ''">
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="name"
          outlined
          @input="$emit('input', name)"
          :dense="$root.dense"
          :rules="rules"
          class="template-input"
          label="Template Name"
        />
      </v-col>
      <!-- <v-col cols="12" sm="4">
        <v-text-field
          v-model="heading"
          outlined
          :dense="$root.dense"
          :rules="rules"
          class="template-input"
          label="Template Heading"
        />
      </v-col> -->
      <v-col
        cols="12"
        sm="6"
        class="d-flex"
        :class="$root.isMobile ? '' : 'justify-end'"
      >
        <v-select
          class="template-input"
          :full-width="false"
          outlined
          :dense="$root.dense"
          label="Template Type"
          item-text="name"
          item-value="value"
          :items="types"
          v-model="type"
          disabled
        >
        </v-select>
      </v-col>
    </v-row>
    <v-alert dense type="info">
      {{ message }}
    </v-alert>
  </div>
</template>

<script>
import types from "../../../assets/js/types";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    way: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      type: 0,
      name: "",
      rules: [(v) => !!v || "Template Name is required."],
      messages: [
        "To insert any Global or Service specific field in the template, please type @ and field name and then select the desired field name from auto complete results.",
        "To insert any Global or Service specific field in the template, please type @ and field name and then select the desired field name from auto complete results.",
      ],
      types: [],
    };
  },
  computed: {
    isAlert() {
      return this.type !== 2 && this.type !== 1;
    },
    message() {
      return this.type === 0 ? this.messages[0] : this.messages[1];
    },
  },
  watch: {
    name(val) {
      this.$emit("input", val);
    },
  },
  mounted() {
    const vm = this;
    vm.name = vm.value;
    vm.types = types;
    vm.type = vm.way;
  },
};
</script>

<style lang="scss">
.template-input {
  max-width: 300px;
}
</style>
